import React from 'react'
import Footer from '../Components/Footer'
import Navbar from '../Components/Navbar'
import Price from '../Components/Pricing'


const Pricing = () => {
    return (
        <>
            <Navbar/>
            <Price/>
            <Footer/>

            
        </>
    )
}

export default Pricing
